<div class="row">
  <div class="col-md-7 col-lg-12 col-xxl-7">
    <sb-card>
      <div card-body>
        <div class="row mt-3 mb-4">
          <div class="col-md-7">
            <h2>{{playerHardware?.name ? playerHardware?.name : ('lang.globals.noValue' | translate)}}</h2>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-5">
            <h5>{{'lang.globals.logo' | translate}}</h5>
            <div class="header-wrapper" style="position: relative;">
              <div class="userPicEdit userPicEditFar cursor-pointer"
                   *ngIf="!playerHardware?.global"
                   (click)="pickAmbiance('LOGO')">
                <sb-icon class="icon-center" icon="edit"></sb-icon>
              </div>
              <img style="object-fit: cover; height: auto; width: 100%;" [src]="logoUrl"
                   alt="./assets/img/channel-placeholder.png"/>
            </div>
          </div>
          <div class="col-md-5">
            <h5>{{'lang.globals.depiction' | translate}}</h5>
            <div class="header-wrapper" style="position: relative;">
              <div class="userPicEdit userPicEditFar cursor-pointer"
                   *ngIf="!playerHardware?.global"
                   (click)="pickAmbiance('DEPICTION')">
                <sb-icon class="icon-center" icon="edit"></sb-icon>
              </div>
              <img style="object-fit: cover; height: auto; width: 100%;" [src]="depictionUrl"
                   alt="./assets/img/channel-placeholder.png"/>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>{{'lang.devices.editDeviceHardware.os' | translate}}</h5>
              <span
                class="text-muted">{{playerHardware?.os ? playerHardware?.os : ('lang.globals.noValue' | translate)}}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>{{'lang.devices.editDeviceHardware.version' | translate}}</h5>
              <span
                class="text-muted">{{playerHardware?.version ? playerHardware?.version : ('lang.globals.noValue' | translate)}}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>{{'lang.devices.editDeviceHardware.manufacturer' | translate}}</h5>
              <span
                class="text-muted">{{playerHardware?.manufacturer ? playerHardware?.manufacturer.name : ('lang.globals.noValue' | translate)}}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>{{'lang.globals.description' | translate}}</h5>
              <span
                class="text-muted">{{playerHardware?.description ? playerHardware?.description : ('lang.globals.noValue' | translate)}}</span>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>
<ng-container *sbPageAction>
  <a
    *ngIf="!playerHardware?.global"
    [queryParams]="{returnTo: this.util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.deviceHardwareEdit"
    [pathParams]="[{id:'playerHardwareID', value: playerHardwareID}]">
    <button class="btn btn-secondary">
      <sb-icon icon="edit" class="mr-1"></sb-icon>
      {{'lang.globals.edit' | translate}}</button>
  </a>
</ng-container>
